// extracted by mini-css-extract-plugin
export default {"tablehead":"TablePackageBox_tablehead__f-LV8","custom-striped-table":"TablePackageBox_custom-striped-table__WPw85"};